module.exports = __webpack_public_path__ + "img/all-inkl_banner_157x54_oekostromv1.f234fdd1.png";